import { amountAsCurrency, amountAsPercent } from "currency";
import { isEmpty } from "lodash";
import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import CommissionBreakdown from "./CommissionBreakdown";
import { Carriers } from "../../../../../logos";
import { TransactionDetails } from "../../../types";
import CardText from "../../CardText";
import { PaymentMethod } from "../../PaymentMethod";
import TransactionCard from "../../TransactionCard";

type Props = {
  commission?: TransactionDetails["commission"];
};

export default function CommissionCard({ commission }: Props) {
  const tailwind = useTailwind();

  if (isEmpty(commission)) {
    return null;
  }

  const {
    saleType,
    paymentMethod,
    breakdown,
    feeBips,
    feeCents,
    currency,
    saleSource,
    deliveryCommission,
  } = commission;

  const percent = amountAsPercent(feeBips);
  const cents = amountAsCurrency({ amount: feeCents, currency });
  const appliedCommission =
    feeBips && feeCents ? `${percent} + ${cents}` : "Gratis";

  const commissions = [
    {
      feeType: saleType,
      feeTypeDetails: paymentMethod,
      feeLabel: "Procesamiento",
      fee: appliedCommission,
    },
    ...(deliveryCommission
      ? [
          {
            feeType: "Envío coordinado",
            feeTypeDetails: "Multientrega",
            feeLabel: "Envío",
            fee: amountAsPercent(deliveryCommission.feeBips),
          },
        ]
      : []),
    ...(saleSource
      ? [
          {
            feeType: saleSource.source,
            feeTypeDetails: saleSource.source,
            feeLabel: saleSource.source,
            fee: amountAsPercent(saleSource.feeBips),
          },
        ]
      : []),
  ];

  // TODO: types
  const renderComissionType = (commissions: any[]) => {
    return (
      <View style={tailwind("mt-4")}>
        <CardText.Subtitle
          text="Tipo de transacción"
          style={tailwind("mb-2")}
        />
        <View style={tailwind("gap-1")}>
          {commissions.map((commission, index) => (
            <View
              key={index}
              style={tailwind("flex-row justify-between items-center mb-1")}
            >
              <CardText.Body
                text={commission.feeType}
                style={tailwind("flex-1")}
              />
              {deliveryCommission &&
              commission.feeType == "Envío coordinado" ? (
                <Carriers.Logotype
                  carrier={deliveryCommission.carrier}
                  height={20}
                />
              ) : (
                <PaymentMethod
                  paymentMethod={commission.feeTypeDetails}
                  showText
                />
              )}
            </View>
          ))}
        </View>
      </View>
    );
  };

  const renderComissionDetails = (commissions: any[]) => {
    return (
      <View style={tailwind("mt-4")}>
        <CardText.Subtitle text="Comisiones" style={tailwind("mb-2")} />
        {commissions.map((commission, index) => (
          <View
            key={index}
            style={tailwind("flex-row justify-between items-center mb-1")}
          >
            <CardText.Body text={commission.feeLabel} />
            <CardText.Body text={commission.fee} />
          </View>
        ))}
      </View>
    );
  };

  return (
    <TransactionCard>
      <CardText.Title text="Comisiones" />
      {renderComissionType(commissions)}
      {renderComissionDetails(commissions)}
      <CommissionBreakdown breakdown={breakdown} currency={currency} />
    </TransactionCard>
  );
}
